import type { GetStaticProps, NextPage } from "next";

import { getLegalDoc } from "~/content/legal";
import type { LegalDoc } from "~landing/content/legal-types";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { LegalView } from "~landing/views/legal";
import { useEffect } from "react";
import { sendPublicPageViewEvent } from "~tag-manager/send-event";

const SLUG = "security";

const SecurityPage: NextPage<LegalDoc> = (props) => {
	useEffect(() => {
		sendPublicPageViewEvent({ page_category: "legal" });
	}, []);

	return (
		<>
			<MarketingSeo
				path="/security"
				title={props.frontmatter.seoTitle}
				description={props.frontmatter.description}
			/>
			<LegalView {...props} />
		</>
	);
};

export const getStaticProps: GetStaticProps<LegalDoc> = async () => ({
	props: await getLegalDoc(SLUG),
});

export default SecurityPage;
